import { render } from "./CompanyForm.vue?vue&type=template&id=f61eb4c0"
import script from "./CompanyForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyForm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/company/components/CompanyForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f61eb4c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f61eb4c0', __exports__)) {
    api.reload('f61eb4c0', __exports__)
  }
  
  module.hot.accept("./CompanyForm.vue?vue&type=template&id=f61eb4c0", () => {
    api.rerender('f61eb4c0', render)
  })

}


export default __exports__